export default __webpack_public_path__ + "static/magnify-logo-9bb8560d437b06e54bae08a414ee48c1.png";